export const pluralSizeClassName = (size) => size ? `are-${size}` : undefined;
export const sizeClassName = (size) => size ? `is-${size}` : undefined;
